import SalesProperties from '../views/SalesProperties';
import SalesProperty from '../views/SalesProperty';
import SalesPropertyOffers from '../views/SalesPropertyOffers';
import SalesPropertyStatistics from '../views/SalesPropertyStatistics';
import SalesPropertyViewings from '../views/SalesPropertyViewings';
import SalesPropertyWrapper from '../views/SalesPropertyWrapper';

export default [
    {
        path: '/sales-properties',
        name: 'sales-properties',
        component: SalesProperties,
        meta: {
            title: 'Sales Properties',
        },
    },
    {
        path: '/sales-properties/:id',
        component: SalesPropertyWrapper,
        meta: {
            title: 'Sales Property',
        },
        pathToRegexpOptions: {
            strict: true,
        },
        children: [
            {
                path: '',
                name: 'sales-property',
                component: SalesProperty,
                pathToRegexpOptions: {
                    strict: false,
                },
            },
            {
                path: 'viewings',
                name: 'sales-property-viewings',
                component: SalesPropertyViewings,
                pathToRegexpOptions: {
                    strict: false,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.vendors.viewings) {
                        return next({
                            name: 'sales-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'offers',
                name: 'sales-property-offers',
                component: SalesPropertyOffers,
                pathToRegexpOptions: {
                    strict: false,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.vendors.offers) {
                        return next({
                            name: 'sales-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'statistics',
                name: 'sales-property-statistics',
                component: SalesPropertyStatistics,
                pathToRegexpOptions: {
                    strict: false,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.vendors.statistics) {
                        return next({
                            name: 'sales-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
        ],
    },
];
